<template>
  <v-app>

    <v-app-bar 
  :elevation="4" 
  style="z-index: 1005; background: url('img/logos/menu-abr-bg.png.jpg') no-repeat center center;background-size: 100% auto; opacity: 90%;" 
  height="60px"
  class="px-0"
  fixed
>
  <!-- Left Navigation Icon -->
  <v-app-bar-nav-icon style="color:#4036ff;" @click="leftDrawer = !leftDrawer"></v-app-bar-nav-icon>
  
  <!-- Title and Logo -->
  <v-layout row align-center justify-center class="ma-0" style="flex: 1;">
    <h2 style="color: #948819; font-family: 'Roboto', sans-serif; font-size: 20px; font-weight: bold; text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5); margin: 0;">
      <!-- SILVER CITY -->
    </h2>
  </v-layout>
  
  <!-- Right Navigation Icon -->
  <v-app-bar-nav-icon style="color:#4036ff;" @click="rightDrawer = !rightDrawer"></v-app-bar-nav-icon>
</v-app-bar>




    <!-- Left Drawer -->
    <FiltersPanel v-model="leftDrawer" />

    <!-- Main Content -->
    <v-main>
      <v-card class="mt-4" height="89.4%">
        <v-toolbar flat dense>
          <!-- <v-app-bar-nav-icon style="color:#03396c" @click="leftDrawer = !leftDrawer"></v-app-bar-nav-icon>
          <v-spacer></v-spacer>
          
          <v-layout row align-center justify-space-between class="ma-0">
            <v-spacer></v-spacer>
            <img src="img/logos/Silver_City_Logo.png" height="80px" class="mx-0" />
            <h2 class="gradient-text">SILVER CITY</h2>
            <v-spacer></v-spacer>
          </v-layout>

          <v-spacer></v-spacer>
          <v-app-bar-nav-icon style="color:#03396c" @click="rightDrawer = !rightDrawer"></v-app-bar-nav-icon> -->
        </v-toolbar>

        <div class="gradient-bg" style="height: 100%">
          <v-divider></v-divider>
          <v-card-text style="height: 100%" class="pa-1">
            <GeoJsonMap />
          </v-card-text>
        </div>
      </v-card>
    </v-main>

    <!-- Right Drawer -->
    <VisualizationPanel v-model="rightDrawer" />

    <!-- Loading Overlay -->
    <v-overlay :opacity="0.8" :value="loading">
      <v-progress-circular indeterminate size="100">
        Loading...
      </v-progress-circular>
    </v-overlay>
  </v-app>
</template>


<script>
import { mapState, mapGetters } from 'vuex';
import L from "leaflet";
import chroma from "chroma-js";


import FiltersPanel from '@/components/filters/FiltersPanel.vue';
import GeoJsonMap from '@/components/GeoJsonMap.vue';
import VisualizationPanel from '@/components/visualizations/VisualizationPanel.vue';


import shp from "shpjs";
import Axios from "axios";
import JsonExcel from "vue-json-excel";

export default {
  components: {
    FiltersPanel,
    GeoJsonMap,
    downloadExcel: JsonExcel,
    VisualizationPanel
  },
  // props: {themeID: String, indicatorID: String, source: String, yeart: String},
  data() {
    return {

      showGeoJsonLayer: true,
      tableHeaders: [
        { text: 'Plot ID', value: 'plot_id' },
        { text: 'Dimensions', value: 'Dimensions' },
        { text: 'Zone', value: 'Zone' },
        { text: 'Owner', value: 'J_Owner' },
        { text: 'Status', value: 'SoldStatus' }
      ],

      // Add new filter selections
      selectedCategory: null,
      selectedZone: null,
      selectedDimension: null,
      selectedOwner: null,
      selectedStatus: null,
      // Counters for available options
      categoryCounter: 0,
      zoneCounter: 0,
      dimensionCounter: 0,
      ownerCounter: 0,
      statusCounter: 0,


      tempProv: [],
      firstloaded: true,
      stepper: 0,
      colortemp: [],
      ranger: [],
      mode: "",
      unit: "",
      totalValuesPro: [],
      totalValuesNat: [],
      proRadio: false,
      natRadio: false,
      DisagRadiosNat: null,
      xAxisNatSex: [],
      xAxisNatRes: [],
      tempTotal: false,
      tempSex: [],
      tempResi: [],
      DisagRadios: null,
      genderSr: [],
      residenceSr: [],
      xAxis: [],

      radioDistrict: false,
      radioDivision: false,
      radioProvince: false,
      showradiobuttons: false,
      radios: null,

      yearListDrop: [],
      selectedYear: "",
      sourceListDrop: [],
      selectedSource: "",
      loading: true,
      leftDrawer: true,
      rightDrawer: false,
      baseMaps: {
        dark: {
          url:
            "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png",
          maxZoom: 20,
        },
        gray: {
          url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          maxZoom: 20,
        },
      },
      minZoom: 9,
      zoom: 15,
      center: [33.541393, 72.198702],
      bounds: null,
      shapefile: {
        loaded: false,
        geojson: null,
      },
      showNationaleShp: false,
      showProvinceShp: false,
      showDivisionShp: false,
      showDistrictShp: false,
      baseMap: "Grey",
      themecounter: 0,
      indiCounter: 0,
      sourceCounter: 0,
      yearCounter: 0,
      levelCounter: 0,
      provinceCounter: 0,
      divisionCounter: 0,
      districtCounter: 0,
      maxBounds: L.latLngBounds([
        [37.0841, 60.8729], // Northernmost and Westernmost point
        [23.6345, 77.8374]
      ]),
      themeList: [],
      themeId: "",
      indicatorsList: [],
      indicatorId: "",
      indicatorData: [],
      // districtData: [],
      year: "",
      dasy: [], // data after source and year filter
      districtData: [],
      divisionData: [],
      provinceData: [],
      nationalData: [],
      filterVals: [],
      selectedFilter: [],
      selectedDistrict: "",
      selectedDivision: "",
      selectedProvince: "",
      districtDrop: [],
      divisionDrop: [],
      provinceDrop: [],
      bottomsheet: false,
      showDisaggregation: true,
      search: "",
      tab: 0,
      ctab: 0,
      sr: [
        {
          name: "",
          data: [],
        },
      ],
      chartoptions: {
        legend: {
          showForSingleSeries: true,
          showForNullSeries: false,
          showForZeroSeries: true,
        },
        stroke: {
          curve: "smooth",
        },
        markers: {
          size: 5,
        },
        // chart: {
        //   id: "UNChart",
        //   height: 350,
        // },
        tooltip: {
          shared: true,
          intersect: false,
        },

        xaxis: {
          categories: [],
          axisBorder: {
            show: true,
            color: "#a24187",
            height: 1,
            width: "100%",
            offsetX: 0,
            offsetY: 0,
          },
          axisTicks: {
            show: true,
            borderType: "solid",
            color: "#a24187",
            height: 10,
            offsetX: 0,
            offsetY: 0,
          },
        },
        yaxis: {
          forceNiceScale: true,
          // min: 0,
          // max: 100,
          floating: false,

          axisBorder: {
            show: true,
            color: "#a24187",
            offsetX: 0,
            offsetY: 0,
          },
          axisTicks: {
            show: true,
            borderType: "solid",
            color: "#a24187",
            width: 6,
            offsetX: 0,
            offsetY: 0,
          },
          crosshairs: {
            show: true,
            position: "back",
            stroke: {
              color: "#b6b6b6",
              width: 1,
              dashArray: 0,
            },
          },
        },
        title: {
          text: undefined,
          align: "left",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "14px",
            fontWeight: "bold",
            fontFamily: undefined,
            color: "#263238",
          },
        },
        dataLabels: {
          enabled: false,
          offsetY: 100,
          style: {
            fontSize: "14px",
            colors: ["#696969"],
          },
        },
      },
      tempData: [],
      tempCategory: [],
      tableData: [],
    };
  },

  methods: {

     // Filter change handlers
     handleCategoryChange() {
      this.$store.dispatch('geojson/updateFilter', {
        filterType: 'category',
        value: this.selectedCategory
      });
    },

    handleZoneChange() {
      this.$store.dispatch('geojson/updateFilter', {
        filterType: 'zone',
        value: this.selectedZone
      });
    },

    handleDimensionChange() {
      this.$store.dispatch('geojson/updateFilter', {
        filterType: 'dimensions',
        value: this.selectedDimension
      });
    },

    handleOwnerChange() {
      this.$store.dispatch('geojson/updateFilter', {
        filterType: 'owner',
        value: this.selectedOwner
      });
    },

    handleStatusChange() {
      this.$store.dispatch('geojson/updateFilter', {
        filterType: 'soldStatus',
        value: this.selectedStatus
      });
    },

    styleGeoJson(feature) {
      const baseStyle = {
        weight: 1,
        opacity: 1,
        fillOpacity: 0.7,
        color: '#666'
      };

      const props = feature.properties;
      if (!props) return baseStyle;

      if (props.Category === 'Plot') {
        return {
          ...baseStyle,
          fillColor: this.getDimensionColor(props.Dimensions)
        };
      }
      return {
        ...baseStyle,
        fillColor: this.getCategoryColor(props.Category)
      };
    },

    getDimensionColor(dimension) {
      const colors = {
        '30 x 52.5': '#1E88E5',
        '38 x 71': '#43A047',
        '50 x 90': '#E53935',
        '40 x 60': '#FDD835',
        '25 x 45': '#8E24AA'
      };
      return colors[dimension] || '#757575';
    },

    getCategoryColor(category) {
      const colors = {
        'Community Center': '#FF7043',
        'Educational Complex': '#9C27B0',
        'Green/Open Space': '#4CAF50',
        'Mosque': '#2196F3',
        'Park/Playground': '#8BC34A',
        'Road': '#9E9E9E',
        'School': '#3F51B5'
      };
      return colors[category] || '#757575';
    },

    onEachGeoJsonFeature(feature, layer) {
      layer.on({
        mouseover: (e) => {
          const layer = e.target;
          layer.setStyle({
            weight: 2,
            fillOpacity: 0.9
          });
        },
        mouseout: (e) => {
          const layer = e.target;
          layer.setStyle(this.styleGeoJson(feature));
        }
      });

      if (feature.properties && feature.properties.Label) {
        layer.bindTooltip(feature.properties.Label, {
          permanent: false,
          sticky: true,
          direction: 'top'
        });
      }
    },

    genderChart() {
      this.sr = this.genderSr;
      this.chartoptions = {
        ...this.chartoptions,
        ...{
          xaxis: { categories: this.xAxis },
          // title: { text: this.filter.theme.name },
        },
      };
    },
    residenceChart() {

      this.sr = this.residenceSr;
      this.chartoptions = {
        ...this.chartoptions,
        ...{
          xaxis: { categories: this.xAxis },
          // title: { text: this.filter.theme.name },
        },
      };
    },
    totalChart() {

      // if (this.genderSr.lenth > 0) {
      this.sr = this.totalValuesPro;
      this.chartoptions = {
        ...this.chartoptions,
        ...{
          xaxis: { categories: this.xAxis },
          // title: { text: this.filter.theme.name },
        },
      };
      // } else this.updatechart();
    },
    genderChartNat() {
      this.sr = this.genderSr;
      this.chartoptions = {
        ...this.chartoptions,
        ...{
          xaxis: { categories: this.xAxisNatSex },
          // title: { text: this.filter.theme.name },
        },
      };
    },
    residenceChartNat() {
      this.sr = this.residenceSr;
      this.chartoptions = {
        ...this.chartoptions,
        ...{
          xaxis: { categories: this.xAxisNatRes },
          // title: { text: this.filter.theme.name },
        },
      };
    },
    totalChartNat() {
      // if (this.genderSr.lenth > 0) {
      this.sr = this.totalValuesNat;
      this.chartoptions = {
        ...this.chartoptions,
        ...{
          xaxis: { categories: this.xAxisNatRes },

        },
      };

    },

    getHeaders() {
      var sex = 0;
      var age = 0;
      var residence = 0;
      var district = 0;
      var division = 0;
      var province = 0;
      var sd1 = 0;
      var sd2 = 0;
      var sd3 = 0;
      var head = [];

      for (let index = 0; index < this.tableData.length; index++) {
        if (this.tableData[index].sex != "") {
          sex = 1;
        }
        if (this.tableData[index].residence != "") {
          residence = 1;
        }
        if (this.tableData[index].district != null) {
          district = 1;
        }
        if (this.tableData[index].division != null) {
          division = 1;
        }
        if (this.tableData[index].province != null) {
          province = 1;
        }
        if (this.tableData[index].age_group != "") {
          age = 1;
        }
        if (this.tableData[index].specific_description1 != "" && this.tableData[index].specific_description1 != null) {
          sd1 = 1;
        }
        if (this.tableData[index].specific_description2 != "" && this.tableData[index].specific_description2 != null) {
          sd2 = 1;
        }
        if (this.tableData[index].specific_description3 != "" && this.tableData[index].specific_description3 != null) {
          sd3 = 1;
        }
        // break;
      }
      head.push({ text: "Survey Level", value: "survey_level" });

      if (province == 1) {
        head.push({ text: "Province", value: "province" });
      }
      if (division == 1) {
        head.push({ text: "Division", value: "division" });
      }
      if (district == 1) {
        head.push({ text: "District", value: "district" });
      }
      if (residence == 1) {
        head.push({ text: "Residence", value: "residence" });
      }
      if (sex == 1) {
        head.push({ text: "Sex", value: "sex" });
      }

      if (age == 1) {
        head.push({ text: "Age", value: "age_group" });
      }
      if (sd1 == 1) {
        head.push(
          { text: "Disaggregation Title 1", value: "specific_name1" },
          { text: "Disaggregation Description 1", value: "specific_description1" }
        );
      }

      if (sd2 == 1) {
        head.push(
          { text: "Disaggregation Title 2", value: "specific_name2" },
          { text: "Disaggregation Description 2", value: "specific_description2" }
        );
      }
      if (sd3 == 1) {
        head.push(
          { text: "Disaggregation Title 3", value: "specific_name3" },
          { text: "Disaggregation Description 3", value: "specific_description3" }
        );
      }

      head.push({ text: "Value " + "(" + this.unit + ")", value: "current_value" });
      return head;

    },
    updatechart() {
      // this.criteria = "";
      this.tempCategory = [];
      this.tempData = [];
      this.sr = [
        {
          name: "",
          data: [],
        },
      ];
      this.chartoptions = {
        ...this.chartoptions,
        ...{
          xaxis: { categories: [] },
          title: { text: " " },
        },
      };
    },

    makeChartDistrict() {
      // var xaxis = [];
      this.tab = 0;
      var tempCategory = [];
      var tempData = [];

      for (let index = 0; index < this.districtData.length; index++) {
        // if ((this.districtData[index].specific_description1 == "" || this.districtData[index].specific_description1 == null) &&
        //   (this.districtData[index].specific_description2 == "" || this.districtData[index].specific_description2 == null) &&
        //   (this.districtData[index].specific_description3 == "" || this.districtData[index].specific_description3 == null))
        // {
        if (this.selectedFilter.length > 0) {
          if (this.selectedFilter.includes(this.districtData[index].district)) {
            tempData.push(this.districtData[index].current_value);
            tempCategory.push(this.districtData[index].district);
          }
        }
        else {
          tempData.push(this.districtData[index].current_value);
          tempCategory.push(this.districtData[index].district);
        }
        // }
      }
      this.sr = [
        {
          name: "Value",
          data: tempData,
        },
      ];

      this.chartoptions = {
        ...this.chartoptions,
        ...{
          xaxis: { categories: tempCategory },
          title: { text: " " },
        },
      };

    },
    makeChartDivision() {
      this.tab = 0;
      var tempCategory = [];
      var tempData = [];

      for (let index = 0; index < this.divisionData.length; index++) {

        if (this.selectedFilter.length > 0) {
          if (this.selectedFilter.includes(this.divisionData[index].division)) {
            tempData.push(this.divisionData[index].current_value);
            tempCategory.push(this.divisionData[index].division);
          }
        }
        else {
          tempData.push(this.divisionData[index].current_value);

          tempCategory.push(this.divisionData[index].division);
        }

      }

      this.sr = [
        {
          name: "Value",
          data: tempData,
        },
      ];
      this.chartoptions = {
        ...this.chartoptions,
        ...{
          xaxis: { categories: tempCategory },
          title: { text: " " },
        },
      };
      // window.dispatchEvent(new Event("resize"));
    },

    resetOnThemeChange() {
      this.tempProv = []
      this.tab = 0;
      this.showChart = true;
      this.totalValuesPro = [];
      this.totalValuesNat = [];
      this.tempSex = [];
      this.tempResi = [];
      this.tempTotal = false;
      this.DisagRadiosNat = null;
      this.proRadio = false;
      this.natRadio = false;

      this.DisagRadios = null;
      this.updatechart();
      this.radios = null;
      this.radioDistrict = false;
      this.radioDivision = false;
      this.radioProvince = false;

      this.indicatorsList = [];
      this.indiCounter = 0;
      this.yearListDrop = [];
      this.yearCounter = 0;
      this.districtData = [];
      this.districtCounter = 0;
      this.divisionData = [];
      this.divisionCounter = 0;
      this.provinceData = [];
      this.provinceCounter = 0;
      this.sourceListDrop = [];
      this.sourceCounter = 0;
      this.showradiobuttons = false;
    },
    resetOnIndicatorChange() {
      this.tempProv = []
      this.tab = 0;

      this.showChart = true;

      this.totalValuesPro = [];
      this.totalValuesNat = [];
      this.tempSex = [];
      this.tempResi = [];
      this.tempTotal = false;
      this.proRadio = false;
      this.natRadio = false;

      this.updatechart();
      this.DisagRadios = null;
      this.DisagRadiosNat = null;

      this.radios = null;
      this.radioDistrict = false;
      this.radioDivision = false;
      this.radioProvince = false;
      this.selectedSource = "";
      this.sourceListDrop = [];
      this.sourceCounter = 0;
      this.yearListDrop = [];
      this.yearCounter = 0;
      this.districtData = [];
      this.districtCounter = 0;
      this.divisionData = [];
      this.divisionCounter = 0;
      this.provinceData = [];
      this.provinceCounter = 0;
      this.showradiobuttons = false;
    },
    resetOnSourceChange() {
      this.tempProv = []
      this.tab = 0;

      this.showChart = true;

      this.totalValuesPro = [];
      this.totalValuesNat = [];
      this.tempSex = [];
      this.tempResi = [];
      this.tempTotal = false;
      this.proRadio = false;
      this.natRadio = false;

      this.updatechart();
      this.DisagRadios = null;
      this.DisagRadiosNat = null;

      this.radios = null;
      this.radioDistrict = false;
      this.radioDivision = false;
      this.radioProvince = false;

      this.yearListDrop = [];
      this.yearCounter = 0;
      this.districtData = [];
      this.districtCounter = 0;
      this.divisionData = [];
      this.divisionCounter = 0;
      this.provinceData = [];
      this.provinceCounter = 0;
      this.showradiobuttons = false;
    },
    resetOnYearChange() {
      this.tempProv = []
      this.tab = 0;

      this.showChart = true;

      this.totalValuesPro = [];
      this.totalValuesNat = [];
      this.tempSex = [];
      this.tempResi = [];
      this.tempTotal = false;
      this.proRadio = false;
      this.natRadio = false;

      this.updatechart();
      this.DisagRadios = null;
      this.DisagRadiosNat = null;

      this.radios = null;
      this.radioDistrict = false;
      this.radioDivision = false;
      this.radioProvince = false;

      this.districtData = [];
      this.districtCounter = 0;
      this.divisionData = [];
      this.divisionCounter = 0;
      this.provinceData = [];
      this.provinceCounter = 0;
    },

    getYear() {

      if (this.firstloaded) {
        this.firstloaded = false;
      }
      this.resetOnSourceChange();
      this.loading = true;
      var dataa = [];
      this.indicatorData.forEach((e) => {
        if (e.data_source_name == this.selectedSource) {
          dataa.push(e);
        }
      });
      this.dasy = dataa;
      this.unit = this.dasy[0].unit;


      this.latestYear(dataa);
      this.loading = false;
      this.resetChart()
    },

    latestYear(data) {
      // getting years and count
      let uniqueYear = [...new Set(data.map((item) => item.current_year))];
      this.yearListDrop = uniqueYear;
      this.yearCounter = 0;
      for (let i = 0; i < this.yearListDrop.length; i++) {
        if (this.yearListDrop[i]) this.yearCounter++;
      }
      // setting the highest year by default
      var yearsList = [];
      var yearCounter = 0;
      var bigYear = 0;
      for (let index = 0; index < data.length; index++) {
        yearsList.push(data[index].current_year);
      }
      for (let i = 0; i < yearsList.length; i++) {
        if (yearsList[i]) yearCounter++;
      }
      bigYear = yearsList[0];
      for (let index = 0; index < yearsList.length; index++) {
        if (bigYear < yearsList[index]) {
          bigYear = yearsList[index];
        }
      }
      this.selectedYear = bigYear;

      this.filterChild();
    },

    async filterChild() {
      this.selectedFilter = []
      this.showradiobuttons = true;
      this.resetOnYearChange();
      var tempData = this.dasy;
      var districtData = [];
      var divisionData = [];
      var provinceData = [];
      var nationalData = [];
      var tempDistrictDisaggr = [];
      this.ranger = [];
      this.stepper = 0;

      // getting national data
      for (let index = 0; index < tempData.length; index++) {
        if (tempData[index].survey_level == "National") {
          nationalData.push(tempData[index]);
        }
      }
      this.nationalData = nationalData;

      // getting district data
      for (let index = 0; index < tempData.length; index++) {
        if (tempData[index].district != null) {
          districtData.push(tempData[index]);
        }
      }
      if (districtData.length > 0) {
        for (let index = 0; index < districtData.length; index++) {
          if (
            (districtData[index].specific_description1 == "" || districtData[index].specific_description1 == null) &&
            (districtData[index].specific_description2 == "" || districtData[index].specific_description2 == null) &&
            (districtData[index].specific_description3 == "" || districtData[index].specific_description3 == null)
          ) {
            tempDistrictDisaggr.push(districtData[index]);
          }
        }

        let uniqueDistrict = [...new Set(districtData.map((item) => item.district))];
        this.districtDrop = uniqueDistrict;
        this.districtData = districtData;
      }
      //getting division data
      for (let index = 0; index < tempData.length; index++) {
        if (tempData[index].division != null) {
          divisionData.push(tempData[index]);
        }
      }
      if (divisionData.length > 0) {
        let uniqueDivision = [...new Set(divisionData.map((item) => item.division))];
        this.divisionDrop = uniqueDivision;
        this.divisionData = divisionData;
      }

      // getting province data
      for (let index = 0; index < tempData.length; index++) {
        if (tempData[index].province != null) {
          provinceData.push(tempData[index]);
        }
      }
      if (provinceData.length > 0) {
        let uniqueProvince = [...new Set(provinceData.map((item) => item.province))];
        this.provinceDrop = uniqueProvince;
        this.provinceData = provinceData;
      }

      // district counter
      for (let i = 0; i < districtData.length; i++) {
        if (districtData[i]) this.districtCounter++;
      }
      // division counter
      for (let i = 0; i < divisionData.length; i++) {
        if (divisionData[i]) this.divisionCounter++;
      }
      // province counter
      for (let i = 0; i < this.provinceData.length; i++) {
        if (this.provinceData[i]) this.provinceCounter++;
      }

      if (tempDistrictDisaggr.length != 0 && tempDistrictDisaggr.length < 30) {
        this.tableData = this.districtData;


        this.updatechart();
        await this.makeChartDistrict();

        this.districtshp();
        this.showDistrictShp = true;
        this.radioDistrict = true;
        this.radios = "district";
        // this.bottomsheet = true;
      }
      // else if (tempDistrictDisaggr.length == 0) {
      //   this.showChart = false;
      // }
      else if (this.divisionCounter > 0) {
        this.tableData = this.divisionData;
        setTimeout(() => {
          var lower = parseFloat(this.divisionData[0].current_value);
          var higher = parseFloat(this.divisionData[0].current_value);
          for (let index = 0; index < this.divisionData.length; index++) {
            if (this.divisionData[index].current_value < lower) {
              lower = parseFloat(this.divisionData[index].current_value);

            }
            if (this.divisionData[index].current_value > higher) {
              higher = parseFloat(this.divisionData[index].current_value);
            }
          }
          lower = Math.floor(lower);
          higher = Math.floor(higher);

          var step = Math.floor((higher - lower) / 5);
          this.stepper = step;
          if (lower < higher) {
            for (let index = lower; index <= higher; index += step) {
              this.ranger.push(index);
            }
          }
        }, 2000);

        this.divisionshp();
        this.showDivisionShp = true;

        this.updatechart();
        await this.makeChartDivision();
        this.filterVals = [...new Set(this.divisionData.map(item => item.division))];

        this.radioDivision = true;
        this.radios = "division";
        // this.bottomsheet = true;
      } else if (this.provinceCounter > 0) {
        this.tableData = this.provinceData;
        this.proDisagSex();

        setTimeout(() => {
          var lower = parseFloat(this.colortemp[0].current_value);
          var higher = parseFloat(this.colortemp[0].current_value);
          for (let index = 0; index < this.colortemp.length; index++) {
            if (this.colortemp[index].current_value < lower) {
              lower = parseFloat(this.colortemp[index].current_value);
            }
            if (this.colortemp[index].current_value > higher) {
              higher = parseFloat(this.colortemp[index].current_value);
            }
          }
          // lower = Math.floor(lower);
          // higher = Math.floor(higher);

          var step = (higher - lower) / 5;
          this.stepper = step;
          if (lower < higher) {
            for (let index = lower; index <= higher; index += step) {
              this.ranger.push(index);
            }
          }
        }, 2000);


        this.filterVals = [...new Set(this.provinceData.map(item => item.province))];
        this.radios = "province";
        this.provinceshp();
        this.showProvinceShp = true;

      } else if (nationalData.length > 0) {
        this.tab = 0;
        this.radios = "national";
        this.tableData = this.nationalData;
        this.proRadio = false;
        this.natRadio = false;
        await this.proDisagSexNat();
        this.loading = true;
        this.selectedDivision = "";
        this.selectedDistrict = "";

        this.showNationaleShp = false;
        this.showProvinceShp = false;
        this.showDistrictShp = false;
        await this.nationalshp();
        this.showNationaleShp = true;
        this.loading = false;
      }
    },

    nationalshp() {
      this.loadShapefile("data/boundary/PAK_adm0");

    },
    districtshp() {
      this.loadShapefile("data/boundary/districtcon");
    },
    provinceshp() {
      this.loadShapefile("data/boundary/PAK_adm1");
    },
    divisionshp() {
      this.loadShapefile("data/boundary/PAK_adm2");
    },
    styledistrict(feature) {
      if (feature) {
        return {
          strokeColor: "#333333",
          strokeWeight: 0.8,
          weight: 0.8,
          color: "#939393",
          opacity: 0.5,
          fillColor: this.fillColordistrict(feature.properties.DISTRICT),
          fillOpacity: 0.9,
        };
      }
    },
    fillColordistrict(chr) {

      for (let index = 0; index < this.districtData.length; index++) {
        // const element = array[index];
        if (chr === this.districtData[index].district) {
          return this.getColors(this.districtData[index].current_value);
        }
      }
    },
    tooltipDistrict(area) {
      if (this.showDistrictShp == true) {
        //Tool Tip Options/ Hover
        var name;
        var value;
        for (let index = 0; index < this.districtData.length; index++) {
          if (area.properties.NAME_1 == this.districtData[index].district) {
            name = this.districtData[index].district;
            value = this.districtData[index].current_value;
          }
        }
        return {
          onEachFeature: function onEachFeature(feature1, layer1) {

            if (feature1.properties.NAME_1 == name) {
              var val = value;
              layer1.bindTooltip(
                `
                  <div>
                  <h3>${name}</h3>
                  <hr style:"color:red">
                    <h4 >Value: ${val}
                    </h4>
                  </div>
            `,
                { permanent: false, sticky: true }
              );
            } else {
              layer1.bindTooltip(
                `
                  <div>
                  <h3>${feature1.properties.NAME_1}</h3>
                  <hr>
                    <h4 >Value: Data Not Present.
                    </h4>
                  </div>
            `,
                { permanent: false, sticky: true }
              );
            }
          },
        };
      }
    },
    styledivision(feature) {


      if (feature) {
        return {
          strokeColor: "#333333",
          strokeWeight: 0.8,
          weight: 0.8,
          color: "#939393",
          opacity: 0.8,
          fillColor: this.fillColordivision(feature.properties.NAME_1),
          fillOpacity: 0.9,
        };
      }
    },
    fillColordivision(chr) {

      for (let index = 0; index < this.divisionData.length; index++) {
        // const element = array[index];
        if (chr === this.divisionData[index].division) {
          return this.getColors(this.divisionData[index].current_value);

          // var mapScale = chroma
          //   .scale(["yellow", "red"])
          //   .classes([0, 20, 40, 60, 80, 100]);
          // return mapScale(this.divListCleaned[index].current_value);
          // // return "#a24187";
        }
      }

      // if (chr === this.options.districts) {
      //   return "red";
      // }
    },
    tooltipDivision(area) {
      //Tool Tip Options/ Hover
      var name;
      var value;

      for (let index = 0; index < this.divisionData.length; index++) {
        if (area.properties.NAME_1 == this.divisionData[index].division) {
          name = this.divisionData[index].division;
          value = this.divisionData[index].current_value;
        }
      }
      return {
        onEachFeature: function onEachFeature(feature1, layer1) {

          if (feature1.properties.NAME_1 === name) {
            var val = value;
            layer1.bindTooltip(
              `
                  <div>
                  <h3>${name}</h3>
                  <hr>
                    <h4 >Value: ${val}
                    </h4>
                  </div>
            `,
              { permanent: true, sticky: true, className: "my-labels" }
            );
          } else {
            layer1.bindTooltip(
              `
                  <div>
                  <h3>${feature1.properties.NAME_1}</h3>
                  <hr>
                    <h4 >Value: Data Not Present.
                    </h4>
                  </div>
            `,
              { permanent: false, sticky: true }
            );
          }
        },
      };
    },
    divisionDetails() {

      this.tab = 0;
      this.ranger = [];
      this.stepper = 0;

      this.radios = "division";
      this.filterVals = [...new Set(this.divisionData.map(item => item.division))];
      this.tableData = this.divisionData;

      // this.bottomsheet = true;

      this.loading = true;
      this.selectedProvince = "";
      this.selectedDistrict = "";


      setTimeout(() => {
        var lower = parseFloat(this.divisionData[0].current_value);
        var higher = parseFloat(this.divisionData[0].current_value);
        for (let index = 0; index < this.divisionData.length; index++) {
          if (this.divisionData[index].current_value < lower) {
            lower = parseFloat(this.divisionData[index].current_value);
          }
          if (this.divisionData[index].current_value > higher) {
            higher = parseFloat(this.divisionData[index].current_value);
          }
        }
        lower = Math.floor(lower);
        higher = Math.floor(higher);

        var step = Math.floor((higher - lower) / 5);
        this.stepper = step;

        if (lower < higher) {
          for (let index = lower; index <= higher; index += step) {
            this.ranger.push(index);
          }
        }
      }, 2000);

      this.showNationaleShp = false;
      this.showProvinceShp = false;
      this.showDistrictShp = false;
      this.divisionshp();
      this.showDivisionShp = true;
      this.loading = false;
      this.updatechart();
      this.makeChartDivision();
    },
    styleProvince(feature) {
      if (feature) {
        return {
          strokeColor: "#333333",
          strokeWeight: 0.8,
          weight: 0.8,
          color: "white",
          opacity: 0.2,
          fillColor: this.fillColorProvince(feature.properties.NAME_1),
          fillOpacity: 0.9,
        };
      }
    },
    fillColorProvince(chr) {
      // var ranger = []
      // var lower = this.provinceData[0].current_value
      //   var higher = this.provinceData[0].current_value

      for (let index = 0; index < this.colortemp.length; index++) {
        // if ( this.provinceData[index].current_value < lower) {
        //     lower = this.provinceData[index].current_value
        //   }
        //   if (this.provinceData[index].current_value > higher) {
        //     higher = this.provinceData[index].current_value

        //   }

        // var step = (higher - lower)/5

        // for (let index = lower; index < higher; index+= step) {
        //     this.ranger.push(index+step)

        // }

        // const element = array[index];
        if (chr === this.colortemp[index].province) {
          // ranger.push(this.provinceData[index].current_value)
          // var abc = this.provinceData[index].current_value
          // ranger.push(abc)

          // this.ranger.push(this.provinceData[index].current_value)

          return this.getColors(this.colortemp[index].current_value);
        }
      }
    },
    tooltipProvince(area) {
      //Tool Tip Options/ Hover
      var name;
      var value;

      for (let index = 0; index < this.colortemp.length; index++) {
        if (area.properties.NAME_1 == this.colortemp[index].province) {
          name = this.colortemp[index].province;
          value = this.colortemp[index].current_value;
        }
      }

      return {
        onEachFeature: function onEachFeature(feature1, layer1) {

          if (feature1.properties.NAME_1 === name) {
            var val = value;

            layer1.bindTooltip(
              `
                  <div>
                  <h3>${name}</h3>
                  <hr>
                    <h4 >Value: ${val}
                    </h4>
                  </div>
            `,
              { permanent: true, sticky: true }
            );

            if (feature1.properties.NAME_1 === "Balochistan") {
              layer1.bindTooltip(
                `
                  <div>
                  <h3>${name}</h3>
                  <hr>
                    <h4 >Value: ${val}
                    </h4>
                  </div>
            `,
                { permanent: true, sticky: true, direction: "left", offset: [-20, -50] }
              );
            }

            if (feature1.properties.NAME_1 === "Sindh") {
              layer1.bindTooltip(
                `
                  <div>
                  <h3>${name}</h3>
                  <hr>
                    <h4 >Value: ${val}
                    </h4>
                  </div>
            `,
                { permanent: true, sticky: true, offset: [0, -50] }
              );
            }
          } else {
            layer1.bindTooltip(
              `
                  <div>
                  <h3>${feature1.properties.NAME_1}</h3>
                  <hr>
                    <h4 >Value: Data Not Present.
                    </h4>
                  </div>
            `,
              { permanent: false, sticky: true }
            );
          }
        },
      };
    },
    // proDisagResi() {
    //   // var tempData = this.provinceData;
    //   var tempSrResi = []; // serial for the charts
    //   var tempResi = []; // filtered single sex disaggregation
    //   // var tempTotal = []; // headline values with no disaggregation
    //   var tempUrbanData = [];
    //   var tempRuralData = [];

    //   // getting sex specific data

    //   // tempData.sort((a, b) => (a.province_id > b.province_id ? 1 : -1));


    //   for (let index = 0; index < tempData.length; index++) {
    //     if (
    //       tempData[index].sex == "" &&
    //       tempData[index].residence != "" &&
    //       tempData[index].age_group == "" &&
    //       tempData[index].specific_description1 == "" &&
    //       tempData[index].specific_description2 == "" &&
    //       tempData[index].specific_description3 == ""
    //     ) {
    //       tempResi.push(tempData[index]);
    //     }
    //   }
    //   // let xAxisCategories = [...new Set(tempData.map((item) => item.province))];

    //   for (let index = 0; index < tempSex.length; index++) {
    //     if (tempSex[index].residence == "Urban") {
    //       tempUrbanData.push(tempResi[index].current_value);
    //     }

    //     if (tempSex[index].residence == "Rural") {
    //       tempRuralData.push(tempResi[index].current_value);
    //     }
    //   }

    //   tempSrResi.push({
    //     name: "Total",
    //     data: tempTotal,
    //   });
    //   // }
    //   if (tempUrbanData.length > 0) {
    //     tempSrResi.push({
    //       name: "Urban",
    //       data: tempMaleData,
    //     });
    //   }
    //   if (tempRuralData.length > 0) {
    //     tempSrResi.push({
    //       name: "Rural",
    //       data: tempFemaleData,
    //     });
    //   }

    //   this.residenceSr = tempSrResi

    // },
    proDisagSex() {
      var tempData = this.provinceData;
      var tempSrSex = []; // serial for the charts
      var tempSex = []; // filtered single sex disaggregation
      var tempTotal = []; // headline values with no disaggregation
      var tempMaleData = [];
      var tempFemaleData = [];
      var tempTransgenderData = [];
      var tempitotali = [];
      // getting sex specific data

      tempData.sort((a, b) => (a.province_id > b.province_id ? 1 : -1));


      for (let index = 0; index < tempData.length; index++) {
        if (
          (tempData[index].sex != "" && tempData[index].sex != null) &&
          (tempData[index].residence == null || tempData[index].residence == "") &&
          (tempData[index].age_group == null || tempData[index].age_group == "") &&
          (tempData[index].specific_description1 == "" ||
            tempData[index].specific_description1 == null) &&
          (tempData[index].specific_description2 == "" ||
            tempData[index].specific_description2 == null) &&
          (tempData[index].specific_description3 == "" ||
            tempData[index].specific_description3 == null)
        ) {
          tempSex.push(tempData[index]);
        }
        if (
          (tempData[index].sex == "" || tempData[index].sex == null) &&
          (tempData[index].residence == "" || tempData[index].residence == null) &&
          (tempData[index].age_group == "" || tempData[index].age_group == null) &&
          (tempData[index].specific_description1 == "" ||
            tempData[index].specific_description1 == null) &&
          (tempData[index].specific_description2 == "" ||
            tempData[index].specific_description2 == null) &&
          (tempData[index].specific_description3 == "" ||
            tempData[index].specific_description3 == null)
        ) {
          tempTotal.push(tempData[index].current_value);
          tempitotali.push(tempData[index]);
        }
      }
      let xAxisCategories = [...new Set(tempData.map((item) => item.province))];
      if (tempitotali.length > 0) {
        this.colortemp = tempitotali;
      } else {
        this.colortemp = tempData;
      }

      // let uniqueSex = [...new Set(tempSex.map((item) => item.sex))];

      for (let index = 0; index < tempSex.length; index++) {
        if (tempSex[index].sex == "Male") {
          tempMaleData.push(tempSex[index].current_value);
        }

        if (tempSex[index].sex == "Female") {
          tempFemaleData.push(tempSex[index].current_value);
        }
        if (tempSex[index].sex == "Transgender") {
          tempTransgenderData.push(tempSex[index].current_value);
        }
      }
      this.tempSex = tempSex;

      tempSrSex.push({
        name: "Total",
        data: tempTotal,
      });
      // }
      if (tempMaleData.length > 0) {
        tempSrSex.push({
          name: "Male",
          data: tempMaleData,
        });
      }
      if (tempFemaleData.length > 0) {
        tempSrSex.push({
          name: "Female",
          data: tempFemaleData,
        });
      }
      if (tempTransgenderData.length > 0) {
        tempSrSex.push({
          name: "Transgender",
          data: tempTransgenderData,
        });
      }

      this.genderSr = tempSrSex;
      this.xAxis = xAxisCategories;

      // --------------------------------------------//
      // --------------------------------------------//
      // --------------------------------------------//
      // --------------------------------------------//
      // --------------------------------------------//
      // var tempData = this.provinceData;
      var tempSrResi = []; // serial for the charts
      var tempResi = []; // filtered single sex disaggregation
      // var tempTotal = []; // headline values with no disaggregation
      var tempUrbanData = [];
      var tempRuralData = [];


      for (let index = 0; index < tempData.length; index++) {
        if (
          (tempData[index].sex == "" || tempData[index].sex == null) &&
          (tempData[index].residence != "" && tempData[index].residence != null) &&
          (tempData[index].age_group == "" || tempData[index].age_group == null)

        ) {
          tempResi.push(tempData[index]);
        }
      }

      // let xAxisCategories = [...new Set(tempData.map((item) => item.province))];


      for (let index = 0; index < tempResi.length; index++) {
        if (tempResi[index].residence == "Urban") {
          tempUrbanData.push(tempResi[index].current_value);
        }

        if (tempResi[index].residence == "Rural") {
          tempRuralData.push(tempResi[index].current_value);
        }
      }
      this.tempResi = tempResi;

      tempSrResi.push({
        name: "Total",
        data: tempTotal,
      });
      // }
      if (tempUrbanData.length > 0) {
        tempSrResi.push({
          name: "Urban",
          data: tempUrbanData,
        });
      }
      if (tempRuralData.length > 0) {
        tempSrResi.push({
          name: "Rural",
          data: tempRuralData,
        });
      }

      this.residenceSr = tempSrResi;

      if (tempSex.length > 0) {
        this.tempTotal = false;

        this.proRadio = true;
        this.genderChart();
        this.DisagRadios = "gender";
      } else if (tempResi.length > 0) {
        this.tempTotal = false;

        this.proRadio = true;

        this.residenceChart();
        this.DisagRadios = "residence";
      } else if (tempSex.length == 0 && tempResi.length == 0 && tempTotal.length > 0) {
        this.totalValuesPro = [];
        this.totalValuesNat = [];
        this.totalValuesPro.push({
          name: "Total",
          data: tempTotal,
        });
        this.proRadio = true;

        this.tempTotal = true;
        this.totalChart();
        this.DisagRadios = "total";
      } else this.showChart = false;
      tempData = [];
    },
    proDisagSexNat() {
      var tempData = this.nationalData;
      var tempSrSex = []; // serial for the charts
      var tempSex = []; // filtered single sex disaggregation
      var tempTotal = []; // headlien values with no disaggregation
      var tempMaleData = [];
      var tempFemaleData = [];
      var tempTransgenderData = [];
      var tempTotalData = [];
      // getting sex specific data

      // tempData.sort((a, b) => (a.province_id > b.province_id ? 1 : -1));


      for (let index = 0; index < tempData.length; index++) {
        if (
          (tempData[index].sex != "" && tempData[index].sex != null) &&
          (tempData[index].residence == "" || tempData[index].residence == null) &&
          (tempData[index].age_group == "" || tempData[index].age_group == null) &&
          (tempData[index].specific_description1 == "" || tempData[index].specific_description1 == null) &&
          (tempData[index].specific_description2 == "" || tempData[index].specific_description2 == null) &&
          (tempData[index].specific_description3 == "" || tempData[index].specific_description3 == null)
        ) {
          tempSex.push(tempData[index]);
        }
        if (
          (tempData[index].sex == "" || tempData[index].sex == null) &&
          (tempData[index].residence == "" || tempData[index].residence == null) &&
          (tempData[index].age_group == "" || tempData[index].age_group == null) &&
          (tempData[index].specific_description1 == "" || tempData[index].specific_description1 == null) &&
          (tempData[index].specific_description2 == "" || tempData[index].specific_description2 == null) &&
          (tempData[index].specific_description3 == "" || tempData[index].specific_description3 == null)
        ) {
          tempTotal.push(tempData[index].current_value);
        }
      }
      let xAxisCategoriesSex = [...new Set(tempData.map((item) => item.sex))];
      xAxisCategoriesSex.filter((x) => x !== "");

      // let uniqueSex = [...new Set(tempSex.map((item) => item.sex))];

      for (let index = 0; index < tempSex.length; index++) {
        if (tempSex[index].sex == "Male") {
          tempMaleData.push(tempSex[index].current_value);
        }

        if (tempSex[index].sex == "Female") {
          tempFemaleData.push(tempSex[index].current_value);
        }
        if (tempSex[index].sex == "Transgender") {
          tempTransgenderData.push(tempSex[index].current_value);
        }
      }
      this.tempSex = tempSex;

      tempSrSex.push({
        name: "Total",
        data: tempTotal,
      });
      // }
      if (tempMaleData.length > 0) {
        tempSrSex.push({
          name: "Male",
          data: tempMaleData,
        });
      }
      if (tempFemaleData.length > 0) {
        tempSrSex.push({
          name: "Female",
          data: tempFemaleData,
        });
      }
      if (tempTransgenderData.length > 0) {
        tempSrSex.push({
          name: "Transgender",
          data: tempTransgenderData,
        });
      }

      this.genderSr = tempSrSex;
      this.xAxisNatSex = ["Gender"];

      // --------------------------------------------//
      // --------------------------------------------//
      // --------------------------------------------//
      // --------------------------------------------//
      // --------------------------------------------//
      // var tempData = this.provinceData;
      var tempSrResi = []; // serial for the charts
      var tempResi = []; // filtered single sex disaggregation
      // var tempTotal = []; // headline values with no disaggregation
      var tempUrbanData = [];
      var tempRuralData = [];

      // getting sex specific data
      // tempData.sort((a, b) => (a.province_id > b.province_id ? 1 : -1));

      for (let index = 0; index < tempData.length; index++) {
        if (
          (tempData[index].sex == "" || tempData[index].sex == null) &&
          (tempData[index].residence != "" && tempData[index].residence != null) &&
          (tempData[index].age_group == "" || tempData[index].age_group == null) &&
          (tempData[index].specific_description1 == "" || tempData[index].specific_description1 == null) &&
          (tempData[index].specific_description2 == "" || tempData[index].specific_description2 == null) &&
          (tempData[index].specific_description3 == "" || tempData[index].specific_description3 == null)

        ) {
          tempResi.push(tempData[index]);
        }
      }
      let xAxisNatRes = [...new Set(tempData.map((item) => item.residence))];


      for (let index = 0; index < tempResi.length; index++) {
        if (tempResi[index].residence == "Urban") {
          tempUrbanData.push(tempResi[index].current_value);
        }

        if (tempResi[index].residence == "Rural") {
          tempRuralData.push(tempResi[index].current_value);
        }
      }
      this.tempResi = tempResi;

      tempSrResi.push({
        name: "Total",
        data: tempTotal,
      });
      // }
      if (tempUrbanData.length > 0) {
        tempSrResi.push({
          name: "Urban",
          data: tempUrbanData,
        });
      }
      if (tempRuralData.length > 0) {
        tempSrResi.push({
          name: "Rural",
          data: tempRuralData,
        });
      }

      this.residenceSr = tempSrResi;
      this.xAxisNatRes = ["Residence"];

      if (tempSex.length > 0) {
        this.tempTotal = false;

        this.natRadio = true;
        this.genderChartNat();
        this.DisagRadiosNat = "gender";
      } else if (tempResi.length > 0) {
        this.natRadio = true;
        this.tempTotal = false;
        this.residenceChartNat();
        this.DisagRadiosNat = "residence";
      } else if (tempSex.length == 0 && tempResi.length == 0 && tempTotal.length > 0) {
        this.totalValuesPro = [];
        this.totalValuesNat = [];
        this.totalValuesNat.push({
          name: "Total",
          data: tempTotal,
        });
        this.natRadio = true;

        this.tempTotal = true;
        this.totalChartNat();
        this.DisagRadiosNat = "total";
      } else this.showChart = false;
    },

    provinceDetails() {
      console.log('in province details');
      this.tab = 0;
      this.radios = "province";
      if (this.tempProv.length == 0) {
        this.tempProv = this.provinceData
        this.filterVals = [...new Set(this.provinceData.map(item => item.province))]
      }
      if (this.tempProv.length > 0 && this.selectedFilter.length == 0) {
        this.provinceData = this.tempProv
      }
      else if (this.selectedFilter.length > 0) {
        this.provinceData = this.tempProv.filter(item => this.selectedFilter.includes(item.province));
      }


      this.tableData = this.provinceData;
      this.proDisagSex();
      this.proRadio = false;
      this.natRadio = false;

      // this.bottomsheet = true;
      this.loading = true;
      this.selectedDivision = "";
      this.selectedDistrict = "";
      this.showNationaleShp = false;
      this.showProvinceShp = false;
      this.showDistrictShp = false;
      this.provinceshp();
      this.showProvinceShp = true;
      this.loading = false;
    },
    async nationalDetails() {
      this.resetChart()
      console.log('in national details');
      this.tab = 0;
      this.radios = "national";

      this.tableData = this.nationalData;
      this.proRadio = false;
      this.natRadio = false;
      this.proDisagSexNat();
      // this.bottomsheet = true;
      this.loading = true;
      this.selectedDivision = "";
      this.selectedDistrict = "";

      this.showNationaleShp = false;
      this.showProvinceShp = false;
      this.showDistrictShp = false;
      await this.nationalshp();

      this.showNationaleShp = true;
      this.loading = false;
    },

    getColors(d, startColor = "#9ec2ff", endColor = "#03018c") {

      const scale = chroma.scale([startColor, endColor]).classes(this.ranger);


      return scale(d).hex();
    },

    async distDetails() {
      this.tab = 0;

      this.filterVals = [...new Set(this.districtData.map(item => item.district))];

      this.tableData = this.districtData;
      // this.bottomsheet = true;

      this.loading = true;
      this.radios = "district";
      this.selectedDivision = "";
      this.selectedProvince = "";

      this.showNationaleShp = false;
      this.showProvinceShp = false;
      this.showDivisionShp = false;
      await this.districtshp();
      this.showDistrictShp = true;
      // this.zoomProvince(district);
      this.updatechart();

      await this.makeChartDistrict();
      this.loading = false;
    },
    zoomProvince(nm) {
      var lat = "";
      var lng = "";
      for (let index = 0; index < this.shapefile.geojson.features.length; index++) {
        if (nm == this.shapefile.geojson.features[index].properties.NAME_1) {
          lat = this.shapefile.geojson.features[index].properties.lng;
          lng = this.shapefile.geojson.features[index].properties.lat;
          // this.styleSelected(this.shapefile.geojson.features[index])
        }
      }

      this.$refs.indiMap.mapObject.flyTo([lat, lng], 9);
    },
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;

    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
    loadShapefile(path) {
      shp(path).then((geojson) => {

        this.shapefile.loaded = true;
        this.shapefile.geojson = geojson;
      });
    },
    getInidicatorList() {
      // this.Themename()
      this.resetChart()
      this.resetOnThemeChange();

      Axios.post(
        `https://ngdp-ncsw.org.pk/api/getIndicatorsList?theme_id=${this.themeId.id}`
      ).then((res) => {
        this.indicatorsList = res.data.quantitative_indicators;
        for (let i = 0; i < this.indicatorsList.length; i++) {
          if (this.indicatorsList[i]) this.indiCounter++;
        }
        if (this.firstloaded) {
          this.indicatorId = this.indicatorsList[1];
          this.getIndicatorData();
        }
        if (this.$route.params.themeID != undefined && this.mode == "fromLandingPage") {
          var inidcatorID = this.$route.params.indicatorID;
          this.setIndicator(inidcatorID);
          this.getIndicatorData();
        }
      });
    },
    async getIndicatorData() {

      this.loading = true;
      this.resetOnIndicatorChange();
      await Axios.post(
        `https://ngdp-ncsw.org.pk/api/getAllIndicatorsDetail?indicator_id=${this.indicatorId.id}`
      ).then((res) => {
        this.indicatorData = res.data.indicators;

        // getting unique source and count
        let uniqueSource = [
          ...new Set(this.indicatorData.map((item) => item.data_source_name)),
        ];
        this.sourceListDrop = uniqueSource;
        this.sourceCounter = 0;
        for (let i = 0; i < this.sourceListDrop.length; i++) {
          if (this.sourceListDrop[i]) this.sourceCounter++;
        }
        if (this.firstloaded) {
          this.selectedSource = this.sourceListDrop[0]
          this.getYear()
        }
        if (this.$route.params.themeID != undefined && this.mode == "fromLandingPage") {
          var source = this.$route.params.source;
          this.selectedSource = source;
          this.getYear();
          this.mode = "";
        }

        // this.filterByDefault();
        this.loading = false;
      });
      this.resetChart()
    },

    setTheme(id) {
      for (let index = 0; index < this.themeList.length; index++) {
        if (id == this.themeList[index].id) {
          var abc = this.themeList[index];
          this.themeId = abc;
        }
      }
    },
    setIndicator(id) {
      for (let index = 0; index < this.indicatorsList.length; index++) {
        if (id == this.indicatorsList[index].id) {
          var abc = this.indicatorsList[index];
          this.indicatorId = abc;
        }
      }
    },
    resetChart() {
      this.selectedFilter = []; // Clear the selectedFilter array

      if (this.radios === 'district') {
        this.makeChartDistrict();
      } else if (this.radios === 'division') {
        this.makeChartDivision();
      } else if (this.radios === 'province') {
        this.provinceDetails();
      }
    },
  },

  computed: {
    ...mapState('geojson', ['geojsonData']),
    ...mapGetters('geojson', [
      'filteredFeatures',
      'categoryOptions',
      'zoneOptions',
      'dimensionOptions',
      'ownerOptions',
      'soldStatusOptions'
    ]),
     // Computed properties for counters
     categoryList() {
      const options = this.categoryOptions || [];
      this.categoryCounter = options.length;
      console.log('Category List:', options, 'Counter:', this.categoryCounter);
      return options;
    },

    zoneList() {
      const options = this.zoneOptions || [];
      this.zoneCounter = options.length;
      console.log('Zone List:', options, 'Counter:', this.zoneCounter);
      return options;
    },

    dimensionList() {
      const options = this.dimensionOptions || [];
      this.dimensionCounter = options.length;
      console.log('Dimension List:', options, 'Counter:', this.dimensionCounter);
      return options;
    },

    ownerList() {
      const options = this.ownerOptions || [];
      this.ownerCounter = options.length;
      return options;
    },

    statusList() {
      const options = this.soldStatusOptions || [];
      this.statusCounter = options.length;
      return options;
    },
    // Computed properties for options with counts
    statusOptions() {
      const options = this.soldStatusOptions || [];
      this.statusCounter = options.length;
      return options;
    }
  },


  watch: {
    geojsonData: {
          immediate: true,
          handler(newData) {
              console.log('GeoJSON Data Changed:', newData ? 'Data Present' : 'No Data');
          }
      },
    // Watch getters for counter updates
    categoryOptions: {
      handler(newVal) {
        this.categoryCounter = newVal.length;
      },
      immediate: true
    },
    zoneOptions: {
      handler(newVal) {
        this.zoneCounter = newVal.length;
      },
      immediate: true
    },
    dimensionOptions: {
      handler(newVal) {
        this.dimensionCounter = newVal.length;
      },
      immediate: true
    },
    ownerOptions: {
      handler(newVal) {
        this.ownerCounter = newVal.length;
      },
      immediate: true
    }
  },

  // computed: {
  //   radioShow() {
  //     if (this.districtCounter > 0) {
  //       return (this.radioDistrict = true);
  //     }
  //     if (this.divisionCounter > 0) {
  //       return (this.radioDivision = true);
  //     }
  //     if (this.provinceCounter > 0) {
  //       return (this.radioProvince = true);
  //     }
  //   },
  // },

  mounted() {
    this.rightDrawer = true
    this.nationalshp();
    this.showNationaleShp = true;
    this.loading = false;
    this.$store.dispatch('geojson/loadGeoJSONData');

    if (this.$route.params.themeID != undefined) {
      this.mode = "fromLandingPage";
      var themeID = this.$route.params.themeID;
      // var inidcatorID = this.$route.params.inidcatorID
      // var source = this.$route.params.source
      // var year = this.$route.params.year

      setTimeout(() => {
        this.setTheme(themeID);
        this.getInidicatorList();
      }, 2000);
    }
  },
  async beforeMount() {
    await Axios.post(`https://ngdp-ncsw.org.pk/api/getThemes`).then(
      (res) => {
        this.themeList = res.data.themes;
        this.themecounter = 0;
        for (let i = 0; i < this.themeList.length; i++) {
          if (this.themeList[i]) this.themecounter++;
        }
        if (this.firstloaded) {

          this.themeId = this.themeList[0];
          this.getInidicatorList()
        }

      }
    );
  },
};
</script>

<style>
.leaflet-tooltip.my-labels {
  color: white;
  background-color: transparent;
  border: transparent;
  box-shadow: none !important;
  font-size: 10px;
  width: fit-content;
  width: -webkit-fit-content;
  width: -moz-fit-content;
}

.inline {
  display: inline;
}
.v-toolbar {
  border-bottom: 1px solid rgba(102, 126, 234, 0.1);
}
</style>
